import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const useTopFilters = (config) => {
  const { data: { top: filters = [] } = {} } = useQuery({
    queryKey: ['filters', config.filters_path],
    queryFn: () => axios.get(config.filters_path).then(({ data }) => data),
    enabled: config.type === 'events',
    staleTime: ms('10m'),
  });

  if (config.staticFilters) return config.staticFilters;

  return { top: filters, overlay: [] };
};
